import { useState } from 'react';
import { LayoutModule } from '../../../layout/modules';
import { FraudTypeFilters } from './filters';
import { FraudTypeList } from './list';
import { FRAUD_TYPE, FRAUD_TYPE_NEW } from '../../../../routes/paths';
import ActionButtonGroup from '../../../components/general/buttons/actionButtonGroup';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { isOnlyViewProfile } from '../../../../shared/types/profiles';
import { Param } from '../../../../shared/types/param';

export const FraudType = () => {
    const [filters, setFilters] = useState<Param>();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    return (
        <>
            <LayoutModule
                title="Búsqueda de tipología de fraude"
                showTitle
                additionalButtons={
                    <ActionButtonGroup
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: FRAUD_TYPE_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: FRAUD_TYPE,
                        }}
                    />
                }
            >
                <FraudTypeFilters onFilter={(filters) => setFilters(filters)} />
            </LayoutModule>
            <FraudTypeList filters={filters} />
        </>
    );
};
